import React from "react";
import AdminWithdrawalsView from "../../views/adminView/adminWithdrawals/adminWithdrawals";

export default function AdminWithdrawals() {
    return <AdminWithdrawalsView />
}